export enum TransactionTypeNew {
	NotSet = 0,
	Sales = 1,
	Invitation = 2,
	Refund = 3,
	Void  = 4,
}



// WEBPACK FOOTER //
// ./src/app/models/transaction-type-new.enum.ts